<script>
import {Line} from 'vue-chartjs'

export default Line.extend({
  name: 'history-chart',
  props: ['chartData', 'barrier', 'settings'],
  data() {
    return {
      options: {
        responsive: false,
        responsiveAnimationDuration: 0,
        animation: {
          duration: 0
        },
        layout: {
          padding: 40
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            fontSize: 40,
            boxWidth: 100,
            padding: 20,
          }
        },
        title: {
          display: false,
        },
        scales: {
          xAxes: [{
            ticks: {
              maxTicksLimit: 12,
              minRotation: 45,
              fontSize: 40,
              labelOffset: 50,
              callback(value, index, values) {
                return value + '   '
              }
            },
            id: 'regular',
            distribution: 'linear',
            time: {
              displayFormats: {
                quarter: 'DD.MM.YYYY'
              }
            },
            gridLines: {
              display: true,
              drawTicks: true,
              tickMarkLength: 20,
            }
          }],
          yAxes: [{
            ticks: {
              maxTicksLimit: 6,
              beginAtZero: false,
              fontSize: 40,
              padding: 40
            },
            gridLines: {
              display: true
            }
          }]
        }
      }
    }
  },
  created() {
    // using https://www.npmjs.com/package/chartjs-lines-plugin

    if (this.settings.barrier) {
      Chart.pluginService.register({
        afterDraw: function (chartInstance) {

          let yValue;
          let yScale = chartInstance.scales["y-axis-0"];
          let canvas = chartInstance.chart;
          let ctx = canvas.ctx;
          let index;
          let line;
          let style;

          if (chartInstance.options.horizontalLine) {

            for (index = 0; index < chartInstance.options.horizontalLine.length; index++) {
              line = chartInstance.options.horizontalLine[index];

              if (!line.style) {
                style = "rgba(169,169,169, .6)";
              } else {
                style = line.style;
              }

              if (line.y) {
                yValue = yScale.getPixelForValue(line.y);
              } else {
                yValue = 0;
              }

              ctx.lineWidth = 5;

              if (yValue) {
                ctx.beginPath();
                ctx.moveTo(60, yValue);
                ctx.lineTo(canvas.width, yValue);
                ctx.strokeStyle = style;
//                ctx.setLineDash([5, 15]);
                ctx.stroke();
              }

              if (yValue) {
                ctx.beginPath();
                ctx.moveTo(60, yScale.getPixelForValue(line.y2));
                ctx.lineTo(canvas.width, yScale.getPixelForValue(line.y2));
                ctx.strokeStyle = style;
//                ctx.setLineDash([5, 15]);
                ctx.stroke();
              }

              if (line.text) {
                ctx.fillStyle = style;
                ctx.fillText(line.text, 1000, yValue - ctx.lineWidth - 30);
              }
            }
          }
        }
      })
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
    this.$emit('generateChartImage', this._chart.toBase64Image())
  }
})
</script>



// WEBPACK FOOTER //
// ChartHistory.vue?6ea87186